import { Heading } from "grommet";
import React from "react";
import "../assets/styles/styles.scss";
import FormBlock from "../components/FormBlock";
import TextInput from "../components/TextInput";
import { TITLES } from "../helpers/formLists";
import SelectInput from "../components/SelectInput";

function SpouseInformation({ control, setValue }) {
  return (
    <>
      <Heading fill level={2}>
      Spouse/Partner Information
      </Heading>

      <FormBlock title={"What is his/her title and name?"}>
        <SelectInput
          control={control}
          name="spouse_title"
          label="Title"
          options={TITLES}
        />

        <TextInput
          control={control}
          name="spouse_first_name"
          label={"First Name"}
        />
        <TextInput
          control={control}
          name="spouse_last_name"
          label={"Last Name"}
        />
      </FormBlock>

    </>
  );
}

export default SpouseInformation;
